import { useState, useContext, useEffect } from 'react';
import { UserContext } from '../UserContext';
import PageContainer from '../components/PageContainer';
import ProfileSection from '../components/account/ProfileSection';
import TwoFactorSection from '../components/account/TwoFactorSection';
import PasswordSection from '../components/account/PasswordSection';
import '../styles/account.css';

const Account = () => {
  const { userId } = useContext(UserContext);
  const [pageLoading, setPageLoading] = useState(true);

  // Set loading to false after initial mount
  useEffect(() => {
    setPageLoading(false);
  }, []);

  const handleLogout = () => {
    console.log('Logout clicked');
  };

  return (
    <PageContainer
      loading={pageLoading}
      loadingMessage="Loading account information..."
      title="Account Settings"
      subtitle="Manage your profile and security settings"
      onLogout={handleLogout}
    >
      {/* .account-page scopes the design tokens and the focus ring; the
          inner wrapper caps the column width and sets the rhythm between
          cards. Both replace the previous inline grid style. */}
      <div className="account-page">
        {/* Profile occupies the left column on its own. The right column
            stacks two independent security cards, two-factor and change
            password, whose combined height (plus the gap between them)
            equals the Profile card's, so the page reads as two balanced
            columns rather than one long card beside two short ones. The
            equalising is done in CSS by .account-security-column; see
            account.css section 1. */}
        <div className="account-sections">
          <ProfileSection userId={userId} />
          <div className="account-security-column">
            <TwoFactorSection />
            <PasswordSection />
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default Account;
